/**
 * Feb 2026 · User-Directive „In allen Kalender-Ansichten: Eintrags-Balken
 * zeigen nur Initialen statt vollen Namen".
 *
 * Reine, seiteneffektfreie Ableitung eines Kürzels aus einem Namen:
 *   • Bis zu 2 Wortanfangsbuchstaben (z.B. „Maria Baumann" → „MB").
 *   • Fällt auf die ersten 2 Zeichen zurück, wenn kein Leerzeichen im
 *     Namen vorkommt (z.B. „Kunde" → „KU").
 *   • Leere/undefined Eingaben liefern „?", damit das Layout nie zerbricht.
 */
export function initialsOf(name) {
  const raw = (name || "").trim();
  if (!raw) return "?";
  const parts = raw.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return raw.slice(0, 2).toUpperCase();
}
